module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-sl.3628a3cf.png";